import * as types from 'Redux/types/tags';
import yup from 'yup';
import { requestOptions } from 'Helpers/Graphql';

import seoTagQuery from 'Gql/queries/market.seoTag.query';
import relatedTagsQuery from 'Gql/queries/market.relatedTags.query';

import seoTagBasicsFragment from 'Gql/fragments/seoTag.basics';

export const seo = (params = {}, req = null) => dispatch => {
    params = {
        ...params,
        slug: params.slug
    };

    return requestOptions({
        req: req,
        type: types.SEO,
        onRetry: seo,
        name: 'marketSeoTag',
        params: params,
        requestParams: {
            slug: params.slug
        },
        validateSuccess: response => Boolean(response.data.tag),
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                tag: yup.object().shape({
                    name: yup.string().required(),
                    slug: yup.string().required()
                }).nullable()
            }).required()
        }),
        query: seoTagQuery
            .replace('%name%', 'marketSeoTag')
            .replace('%fields%', `
                ...seoTagBasics
            `)
            .replace('%fragments%', `
                ${seoTagBasicsFragment}
            `)
    });
};
export const related = (params = {}, req = null) => dispatch => {
    params = {
        ...params,
        slug: params.slug,
        tags: params.tags
    };

    return requestOptions({
        req: req,
        type: types.RELATED,
        onRetry: related,
        name: 'marketSeoTagRelatedTags',
        params: params,
        requestParams: {
            tags: params.tags
        },
        validateSuccess: response => true,
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                relatedTags: yup.array().of(
                    yup.object().shape({
                        name: yup.string().required(),
                        slug: yup.string().required()
                    }).required()
                ).ensure()
            }).required()
        }),
        query: relatedTagsQuery
            .replace('%name%', 'marketSeoTagRelatedTags')
            .replace('%fields%', `
                ...seoTagBasics
            `)
            .replace('%fragments%', `
                ${seoTagBasicsFragment}
            `)
    });
};



// WEBPACK FOOTER //
// ./src/redux/actions/tags.js